// === Address ===

export interface AddressFormData {
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string;
  city: string;
  state?: string;
  postcode: string;
  country: string;
  phone?: string;
}

// === Profile (Edit Account 확장) ===

export interface ProfileFormData {
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  subscribed: boolean;
}
